/* global Office, document */
import LogHelper from "./logHelper";
import constants from './constants?v=2';
import { saveSetting } from './settings';

const logHelper = new LogHelper();

const QuickBooks = function () {
    const self = this;
    // const APIUrl = "http://localhost:3300";
    const APIUrl = "https://api.excel.engineering/caesarqbo";

    function isTokenExpired(tokenObj) {
        if (!tokenObj || !tokenObj.createdAt || !tokenObj.expires_in) return true;
        const now = Date.now();
        // expires_in is in seconds, createdAt is in ms
        const expiryTime = tokenObj.createdAt + (tokenObj.expires_in * 1000);
        // Add a buffer (e.g., 1 minute) to avoid edge cases
        return now > (expiryTime - 60000);
    }

    // Helper to get and parse token
    async function getParsedToken() {
        let token = Office.context.document.settings.get(constants.SettingKeys.QBOToken);
        if (!token) {
            await logHelper.writeLog(logHelper.LogTypes.Error, "User is not authenticated with QBO.");
        }
        const isExpired = isTokenExpired(JSON.parse(token));
        if (isExpired) {
            await logHelper.writeLog(logHelper.LogTypes.Warn, "QBO token expired or missing. Prompting re-authentication.");
            await self.CheckAuthentication(false); // Prompt re-authentication
            token = Office.context.document.settings.get(constants.SettingKeys.QBOToken);
        }
        return token ? JSON.parse(token) : null;
    }

    // Helper to show authentication messages
    function showAuthMessage(isFailed, msg) {
        const qboAuthMsgDiv = document.getElementById("QBOAuthenticationMsg");
        if (!qboAuthMsgDiv) return;
        const msgLabel = qboAuthMsgDiv.getElementsByTagName("label")[0];
        if (!msgLabel) return;
        qboAuthMsgDiv.classList.remove("hide", "success", "error");
        qboAuthMsgDiv.classList.add(isFailed ? "error" : "success");
        msgLabel.textContent = msg;
    }

    // Helper to show authentication messages
    function showUserInfo(userInfo, companyInfo) {
        const qboUserInfoDiv = document.getElementById("QBOUserInfo");
        if (qboUserInfoDiv) {
            const userName = qboUserInfoDiv.getElementsByTagName("label")["QBOUserName"];
            if (userName);
            {
                userName.textContent = userInfo ? `${userInfo.givenName} ${userInfo.familyName} (${userInfo.email})` : "N/A";
            }
            const companyName = qboUserInfoDiv.getElementsByTagName("label")["QBOCompanyName"];
            if (companyName);
            {
                companyName.textContent = companyInfo ? companyInfo.CompanyName : "N/A";
            }
            qboUserInfoDiv.classList.remove("hide");
        }
    }

    // Helper to handle authentication messages
    // This function updates the UI based on authentication status
    function authentication(isFailed, msg,) {
        let qboAuthMsgDiv = document.getElementById("QBOAuthenticationMsg");
        let msgLabel = qboAuthMsgDiv.getElementsByTagName("label")[0];
        let loginBtn = document.getElementById("loginQBOBtn");
        let logoutBtn = document.getElementById("logoutQBOBtn");
        qboAuthMsgDiv.classList.remove("hide");
        //logHelper.writeLog(logHelper.LogTypes.Msg, msg);
        if (isFailed) {
            qboAuthMsgDiv.classList.remove("success");
            qboAuthMsgDiv.classList.add("error");
            loginBtn.classList.remove("hide");
            logoutBtn.classList.add("hide");
            msgLabel.textContent = msg;
        }
        else {
            qboAuthMsgDiv.classList.remove("error");
            qboAuthMsgDiv.classList.add("success");
            loginBtn.classList.add("hide");
            logoutBtn.classList.remove("hide");
            msgLabel.textContent = msg;
        }
    }

    // Helper for fetch with error handling
    async function safeFetch(url, options) {
        try {
            const res = await fetch(url, options);
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        } catch (error) {
            throw error;
        }
    }

    this.CheckAuthentication = async function (openAuthDialog = true) {
        let tokenObj = Office.context.document.settings.get(constants.SettingKeys.QBOToken);
        if (tokenObj) {
            try {
                tokenObj = JSON.parse(tokenObj);
                await logHelper.writeLog(logHelper.LogTypes.Msg, "Checking QuickBooks authentication.");
                const data = await safeFetch(`${APIUrl}/checkAuth`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ token: tokenObj })
                });
                console.log("checkAuth data", data);
                if (data.authenticated) {
                    await logHelper.writeLog(logHelper.LogTypes.Msg, `User is authenticated to QuickBooks with Company ID: ${data.token.realmId}. Is refreshed: ${data.refreshed}`);
                    if (data.refreshed) {
                        saveSetting(constants.SettingKeys.QBOToken, JSON.stringify(data.token));
                        authentication(false, `The user is already logged in to QuickBooks.`);

                    }
                    else {
                        authentication(false, `The user is already logged in to QuickBooks.`);
                    }
                } else {
                    console.log('The user needs to complete authentication to QuickBooks.');
                    await logHelper.writeLog(logHelper.LogTypes.Warn, "The user needs to complete authentication to QuickBooks.");
                    if (openAuthDialog) {
                        openQuickBooksAuthDialogs();  // your displayDialogAsync call
                    }
                }
            } catch (error) {
                console.error("Authentication check failed:", error);
                await logHelper.writeLog(logHelper.LogTypes.Error, `Authentication check failed: ${error.message}`);
                authentication(true, "Authentication check failed.");
            }
        }
        else {
            console.log('The user needs to complete authentication to QuickBooks.');
            await logHelper.writeLog(logHelper.LogTypes.Warn, "The user needs to complete authentication to QuickBooks.");
            if (openAuthDialog) {
                openQuickBooksAuthDialogs();  // your displayDialogAsync call
            };
        }
        return;
    }

    async function openQuickBooksAuthDialogs() {
        try {
            let currentAppUrl = window.location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/"));
            console.log("current App URL", currentAppUrl);
            await logHelper.writeLog(logHelper.LogTypes.Msg, `Opening QuickBooks authentication dialog (false iframe). App URL: ${APIUrl}/authUri?requestedUrl=${currentAppUrl}`);
            const { url } = await safeFetch(`${APIUrl}/authUri?requestedUrl=${currentAppUrl}`);
            Office.context.ui.displayDialogAsync(url, { height: 60, width: 40, displayInIframe: false }, function (result) {
                const dialog = result.value;
                dialog.addEventHandler(Office.EventType.DialogMessageReceived, async function (arg) {
                    try {
                        const data = JSON.parse(arg.message);
                        if (data.status === "success") {
                            await logHelper.writeLog(logHelper.LogTypes.Msg, `QuickBooks authentication successful. Company ID: ${data.token.realmId}`);
                            await saveSetting(constants.SettingKeys.QBOToken, JSON.stringify(data.token));
                            console.log("Token saved to OfficeRuntime storage.");
                            authentication(false, `Successfully Authenticated with QuickBooks.`);
                            dialog.close();
                            new QuickBooks().getUserAndCompanyInfo(); // Fetch user and company info after successful auth

                        } else {
                            await logHelper.writeLog(logHelper.LogTypes.Error, `Authentication failed: ${data.message}`);
                            console.error("Authentication failed:", data.message);
                            authentication(true, data.message);
                        }
                    } catch (err) {
                        await logHelper.writeLog(logHelper.LogTypes.Error, `Dialog message handling error: ${err.message}`);
                        authentication(true, "Authentication dialog error.");
                    }
                });
            });
        } catch (error) {
            console.error("Failed to open authentication dialog:", error);
            await logHelper.writeLog(logHelper.LogTypes.Error, `Dialog message handling error: ${err.message}`);
            authentication(true, "Failed to open authentication dialog.");
        }
    }


    // Generic fetch and cache helper for QBO lists
    async function fetchAndCacheQBOList(settingKey, query, token, isRefreshRequired = false, responseKey) {
        let list = [];
        try {
            const stored = Office.context.document.settings.get(settingKey);
            if (stored && !isRefreshRequired) {
                list = [...JSON.parse(stored)];
                console.log(`${responseKey} data retrieved from settings`);
            } else {
                const data = await safeFetch(`${APIUrl}/quickBooksQuery`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ token: token, query })
                });
                if (data.error) {
                    throw data.error;
                }
                list = [...data.QueryResponse[responseKey]];
                saveSetting(settingKey, JSON.stringify(list));
                console.log(`${responseKey} data retrieved from QBO`);
            }
        } catch (error) {
            await logHelper.writeLog(logHelper.LogTypes.Error, `Error while retrieving ${responseKey} list data: ${error.message}`);
            console.error(`Error while retrieving ${responseKey} list data. Error details are`, error);
        }
        return list;
    }

    // this method retrieves user and company information from QBO
    // and caches them in Office document settings.
    this.getUserAndCompanyInfo = async function () {
        let token = await getParsedToken();
        if (!token) {
            return { showLoginBtn: true };
        };
        authentication(false, `Authenticated with QuickBooks.`);
        let userInfo = Office.context.document.settings.get(constants.SettingKeys.QBOUserInfo);
        let companyInfo = Office.context.document.settings.get(constants.SettingKeys.QBOCompanyInfo);
        if (userInfo) {
            console.log("User info retrieved from settings");
            userInfo = JSON.parse(userInfo);
        }
        else {
            userInfo = await getUserInfo();
            if (userInfo) {
                await saveSetting(constants.SettingKeys.QBOUserInfo, JSON.stringify(userInfo));
            }
        }
        if (companyInfo) {
            console.log("Company info retrieved from settings");
            companyInfo = JSON.parse(companyInfo);
        }
        else {
            console.log("Fetching user and company info from QBO");
            companyInfo = await getCompanyInfo();
            if (companyInfo) {
                await saveSetting(constants.SettingKeys.QBOCompanyInfo, JSON.stringify(companyInfo));
            }
        }
        if (!userInfo || !companyInfo) {
            console.log("Failed to retrieve user or company info.");
            showAuthMessage(true, "Failed to retrieve user or company info.");

        }
        else {
            showUserInfo(userInfo, companyInfo);
        }

    }

    async function getUserInfo() {
        const tokenObj = await getParsedToken();
        try {
            const data = await safeFetch(`${APIUrl}/userInfo`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    token: tokenObj
                })
            });
            console.log("user info, ", data);
            return data;
        } catch (error) {
            console.error("Failed to fetch user info:", error);
            return null
        }
    }
    async function getCompanyInfo() {
        const tokenObj = await getParsedToken();
        try {
            const data = await safeFetch(`${APIUrl}/quickBooksQuery`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    token: tokenObj,
                    query: "select * from CompanyInfo"
                })
            });
            console.log("Company info, ", data);
            if (data.QueryResponse && data.QueryResponse.CompanyInfo && data.QueryResponse.CompanyInfo.length > 0) {
                return data.QueryResponse.CompanyInfo[0];
            } else {
                console.warn("No company info found in response.");
                return null;
            }
        } catch (error) {
            console.error("Failed to fetch company info:", error);
        }
    }

    this.getClassLists = async function (token, isRefreshRequired = false) {
        return await fetchAndCacheQBOList(
            constants.SettingKeys.QBOClassList,
            "select * from Class",
            token,
            isRefreshRequired,
            "Class"
        );
    }
    this.getAllChartOfAccounts = async function (token, isRefreshRequired = false) {
        return await fetchAndCacheQBOList(
            constants.SettingKeys.QBOAccounts,
            "select * from Account STARTPOSITION 1 MAXRESULTS 500",
            token,
            isRefreshRequired,
            "Account"
        );
    }

    function jsonArrayGroupBy(data, key) {
        return data.reduce((acc, item) => {
            const keyValue = item[key];
            if (!acc[keyValue]) acc[keyValue] = [];
            acc[keyValue].push(item);
            return acc;
        }, {});
    }

    function getAccountInfo(accountName, accountLists) {
        if (!accountName || !Array.isArray(accountLists)) return null;
        let [AcctId, ...nameParts] = accountName.trim().split(" ");
        let accountInfo = null;
        // If AcctId is not a number, we assume it's account name start with account ID
        if (AcctId && !isNaN(Number(AcctId))) {
            const acctName = nameParts.join(" ").trim();
            accountInfo = accountLists.find(
                x => x.AcctNum === AcctId && x.Name === acctName
            );
        }
        else {
            AcctId = "0000";
            nameParts = accountName.trim().split(" ");
            const acctName = nameParts.join(" ").trim();
            accountInfo = accountLists.find(x => x.Name === acctName);
        }
        if (!accountInfo) {
            // console.warn(`Account info not found for AcctNum: "${AcctId}" and AccountName: "${acctName}"`);
            return null;
        }
        return { ...accountInfo };
    }

    function getClassInfo(className, classLists) {
        if (!className || !Array.isArray(classLists)) return null;
        const classInfo = classLists.find(x => x.Name === className);
        if (!classInfo) {
            //console.log(`Class info not found in class list where name:${className}`);
            return null;
        }
        return { ...classInfo };
    }

    this.pushJournalEntryOnQbo = async function (sheetData) {
        try {
            await logHelper.writeLog(logHelper.LogTypes.Msg, "Starting process to push Journal entry to QBO.");
            const token = await getParsedToken();
            if (!token) {
                return { ok: false, error: "User is not authenticated with QBO." };
            }
            let classList = await this.getClassLists(token);
            let accountLists = await this.getAllChartOfAccounts(token);
            console.log("Account and class data are retrieved");
            await logHelper.writeLog(logHelper.LogTypes.Msg, "Account and class data are retrieved.");
            let batchObj = { BatchItemRequest: [] };
            let dataGroupByJournalNum = jsonArrayGroupBy(sheetData, "JournalNo");
            console.log("group by journal data ", dataGroupByJournalNum);
            await logHelper.writeLog(logHelper.LogTypes.Msg, `We found ${Object.keys(dataGroupByJournalNum).length} number of journal entries to push.`);
            let count = 0;
            for (let journalNum in dataGroupByJournalNum) {
                count++;
                const docNumber = journalNum;
                const txnDate = dataGroupByJournalNum[journalNum][0]["JournalDate"];
                const lines = [];
                for (const item of dataGroupByJournalNum[journalNum]) {
                    let postingType = "";
                    let amount = "0.0";
                    if (item["Credits"] && parseFloat(item["Credits"]) >= 0) {
                        postingType = "Credit";
                        amount = item["Credits"];
                    } else if (item["Debits"] && parseFloat(item["Debits"]) >= 0) {
                        postingType = "Debit";
                        amount = item["Debits"];
                    } else {
                        continue;
                    }
                    let accountInfo = getAccountInfo(item["AccountName"], accountLists);
                    if (!accountInfo) {
                        accountLists = await this.getAllChartOfAccounts(token, true);
                        accountInfo = getAccountInfo(item["AccountName"], accountLists);
                        if (!accountInfo) {
                            await logHelper.writeLog(logHelper.LogTypes.Error, `Account info still not found for: ${item["AccountName"]}`);
                            continue;
                        }
                    }
                    let classInfo = getClassInfo(item["Class"], classList);
                    if (!classInfo) {
                        classList = await this.getClassLists(token, true);
                        classInfo = getClassInfo(item["Class"], accountLists);
                        if (!classInfo) {
                            await logHelper.writeLog(logHelper.LogTypes.Error, `Class info still not found for: ${item["Class"]}`);
                            continue;
                        }
                    }
                    lines.push({
                        Description: item["Description"],
                        Amount: amount,
                        DetailType: "JournalEntryLineDetail",
                        JournalEntryLineDetail: {
                            PostingType: postingType,
                            AccountRef: {
                                value: accountInfo.Id,
                                name: accountInfo.Name
                            },
                            ClassRef: {
                                value: classInfo.Id,
                                name: classInfo.Name
                            }
                        }
                    });
                }
                batchObj.BatchItemRequest.push({
                    bId: "bJournal" + count + "#" + docNumber,
                    JournalEntry: {
                        TxnDate: txnDate,
                        DocNumber: docNumber,
                        Line: [...lines]
                    },
                    operation: "create"
                });
            }
            console.log("Final JSON object to push Journal entry", batchObj);
            const result = await executeQboBatch(batchObj);
            return result;
        }
        catch (error) {
            await logHelper.writeLog(logHelper.LogTypes.Error, `Error while pushing journal entry data to QBO: ${error.message}`);
            console.error("Error while pushing journal entry data to QBO:", error);
            return { ok: false, error: error };
        }
    }

    async function executeQboBatch(batchObjData) {
        const token = await getParsedToken();
        if (!token) {
            return { ok: false, error: "User is not authenticated with QBO." };
        }
        try {
            await logHelper.writeLog(logHelper.LogTypes.Msg, "Executing QBO batch request to push Journal Entries.");
            const data = await safeFetch(`${APIUrl}/executeQBOBatch`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    token: token,
                    data: JSON.stringify(batchObjData)
                })
            });
            console.log("Batch execute Result List data are, ", data);
            await logHelper.writeLog(logHelper.LogTypes.Msg, "Batch executed.");
            return { ok: true, data };
        } catch (error) {
            await logHelper.writeLog(logHelper.LogTypes.Error, `Batch execution failed: ${error.message}`);
            return { ok: false, error: error };
        }
    }
}

export default QuickBooks;
